(() => {
  const endpoint = 'https://bbsign-creadores.srblasini.chatgpt.site/api/storefront/popular';
  const preview = window.Shopify?.designMode || window.BBShop?.preview || new URLSearchParams(location.search).has('preview_theme_id') || location.hostname.endsWith('shopifypreview.com');
  const sections = [...document.querySelectorAll('[data-popular-products]')].map(section => {
    const grid = section.querySelector('[data-popular-grid]');
    const pool = section.querySelector('[data-popular-pool]');
    if (!grid || !pool) return null;
    const initial = [...grid.children].map(card => card.dataset.productHandle);
    const cards = new Map([...pool.content.children, ...grid.children].map(card => [card.dataset.productHandle, card]));
    return { section, grid, initial, cards, limit: Number(section.dataset.limit) || 6 };
  }).filter(Boolean);
  let lastRefresh = 0;
  let inFlight = false;
  async function refresh() {
    if (!sections.length || document.hidden || inFlight || Date.now() - lastRefresh < 60000) return;
    inFlight = true;
    lastRefresh = Date.now();
    try {
      const response = await fetch(endpoint, { credentials: 'omit', signal: AbortSignal.timeout(5000) });
      if (!response.ok) return;
      const data = await response.json();
      if (!Array.isArray(data.products)) return;
      for (const item of sections) {
        if (item.grid.contains(document.activeElement) || item.grid.matches(':hover')) continue;
        const ranked = data.products.filter(p => p.clicks > 0 && item.cards.has(p.handle)).map(p => p.handle);
        const selected = [...new Set([...ranked, ...item.initial])].slice(0, item.limit);
        if (!selected.length) continue;
        const current = [...item.grid.children].map(card => card.dataset.productHandle);
        if (current.join('|') === selected.join('|')) continue;
        item.grid.replaceChildren(...selected.map(handle => item.cards.get(handle)));
      }
    } catch {} finally { inFlight = false; }
  }
  refresh();
  if (sections.length) {
    setInterval(refresh, 300000);
    document.addEventListener('visibilitychange', refresh);
  }
  if (preview) return;
  const consent = () => window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true;
  if (!window.Shopify?.customerPrivacy && window.Shopify?.loadFeatures) {
    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], () => {});
  }
  const sent = new Set();
  const pending = new Set();
  document.addEventListener('visitorConsentCollected', () => {
    if (!consent()) {
      try { sessionStorage.removeItem('bbs-rotation-visitor'); } catch {}
      sent.clear();
    }
  });
  async function record(event) {
    if (!event.isTrusted || (event.type === 'auxclick' && event.button !== 1) || !consent()) return;
    const link = event.target.closest?.('a[href]');
    if (!link) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin) return;
    const match = url.pathname.match(/\/products\/([a-z0-9][a-z0-9-]{0,99})\/?$/);
    if (!match) return;
    const handle = match[1];
    const day = new Date().toISOString().slice(0, 10);
    const dedupe = day + ':' + handle;
    if (sent.has(dedupe) || pending.has(dedupe)) return;
    try {
      let saved;
      try { saved = JSON.parse(sessionStorage.getItem('bbs-rotation-visitor') || 'null'); } catch {}
      if (!saved || saved.day !== day || typeof saved.id !== 'string') {
        saved = { day, id: crypto.randomUUID() };
        sessionStorage.setItem('bbs-rotation-visitor', JSON.stringify(saved));
      }
      pending.add(dedupe);
      const response = await fetch(endpoint, { method: 'POST', credentials: 'omit', keepalive: true, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ handle, visitor: saved.id }) });
      if (response.ok) sent.add(dedupe);
    } catch {} finally { pending.delete(dedupe); }
  }
  document.addEventListener('click', record);
  document.addEventListener('auxclick', record);
})();
